import React from 'react'
import AutoForm from '@components/AutoForm'
import {Field} from 'simple-react-form'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import Button from '@components/Button'
import useRef from '@hooks/useRef'
import useMutation from '@packages/apollo-hooks/lib/useMutation'
import gql from 'graphql-tag'
import useMessage from '@hooks/useMessage'
import useState from '@hooks/useState'
import SixDigitSmallInput from '@components/fields/SixDigitSmallInput'
import {useRouter} from 'next/router'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import useWebsiteInfo from '@hooks/useWebsiteInfo'
import SignTerms from '@components/SignTerms'
import useEffect from '@hooks/useEffect'
import styles from './styles.module.css'
import isServerSide from '@helpers/misc/isServerSide'

export default function LoginWithCode(props) {
  const {token, onSuccess, setToken, email} = props
  const form = useRef(null)
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const showMessage = useMessage()
  const {websiteId, websiteName} = useWebsiteInfo()

  const [doc, setDoc] = useState({email, token, code: '', websiteId})

  useEffect(() => {
    setDoc({...doc, email, token})
  }, [email, token])

  const mutate = useMutation(gql`
    mutation requestLoginCode($email: String) {
      token: requestLoginCode(email: $email)
    }
  `)

  const {pendingTermInfos} = useQuery({
    query: gql`
      query pending($email: String, $websiteId: String) {
        pendingTermInfos(email: $email, websiteId: $websiteId)
      }
    `,
    variables: {email, websiteId},
    partial: true,
    omit: isServerSide()
  })

  const requiredTermInfos = (pendingTermInfos || []).filter(term => !term.optional)
  const requiredTermVersions = requiredTermInfos.map(term => term.latestVersion)

  const [termSignatures, setTermSignatures] = useState([])

  const signedVersions = termSignatures.map(term => term.version)
  const missingSignatures = requiredTermVersions.some(version => !signedVersions.includes(version))

  const requestAgain = async () => {
    setLoading(true)
    try {
      const {token} = await mutate({email})
      setToken(token)
      showMessage('Enviamos el código a tu correo')
    } catch (error) {
      showMessage(error)
    }
    setLoading(false)
  }

  const digits = 6
  const codeIsReady = doc.code.length >= digits
  const requiredTermsCount = requiredTermVersions.length

  useEffect(() => {
    if (codeIsReady && !requiredTermsCount) form.current.submit()
  }, [codeIsReady, requiredTermsCount])

  const buttonEnabled = codeIsReady && !missingSignatures

  return (
    <AutoForm
      mutation="loginAndSignTerms"
      doc={{
        ...doc,
        termSignatures: missingSignatures ? [] : termSignatures
      }}
      omit="token"
      ref={form}
      onSuccess={onSuccess}>
      <div className="label">Email</div>
      <Field fieldName="email" disabled type={Text} value={doc.email} />
      <div className="label">Código enviado a tu correo</div>
      <Field
        fieldName="code"
        type={SixDigitSmallInput}
        digits={digits}
        onReady={code => {
          setDoc({...doc, code})
          if (code.toUpperCase() === 'PASSWO') {
            router.replace('/login-password')
          }
        }}
      />
      <div className={`description ${styles.message}`}>
        Te enviamos un email con el código para entrar.{' '}
        <a onClick={requestAgain}>Enviar nuevo código</a>
      </div>
      <SignTerms
        websiteId={websiteId}
        websiteName={websiteName}
        termInfos={pendingTermInfos}
        termSignatures={termSignatures}
        setTermSignatures={setTermSignatures}
      />
      <Button
        loading={loading}
        primary
        disabled={!buttonEnabled}
        onClick={() => form.current.submit()}>
        Entrar
      </Button>
      <br />
    </AutoForm>
  )
}
